import { __read, __rest, __spread } from "tslib";
import moment from "moment";
var SEQUENCE_24 = Array(24)
    .fill(0)
    .map(function (_, i) { return i; });
var SEQUENCE_60 = Array(60)
    .fill(0)
    .map(function (_, i) { return i; });
var SEQUENCE_1000 = Array(1000)
    .fill(0)
    .map(function (_, i) { return i; });
export var startOfDay = moment().startOf("day");
export var endOfDay = moment().endOf("day");
export function getHourMinuteSecond(time) {
    return {
        hour: time.hour(),
        minute: time.minute(),
        second: time.second(),
        milliseconds: time.milliseconds(),
    };
}
export function getYearMonthDay(time) {
    return {
        year: time.year(),
        month: time.month(),
        day: time.day(),
    };
}
/**
 * 解析 format
 * @param format
 */
export function genShowHourMinuteSecond(format) {
    // Ref: http://momentjs.com/docs/#/parsing/string-format/
    return {
        showHour: format.indexOf("H") > -1 ||
            format.indexOf("h") > -1 ||
            format.indexOf("k") > -1,
        showMinute: format.indexOf("m") > -1,
        showSecond: format.indexOf("s") > -1,
        showMilliseconds: format.indexOf("SSS") > -1,
    };
}
/**
 * 校验 range
 */
export function isValidRange(range) {
    return (Array.isArray(range) &&
        (moment.isMoment(range[0]) || moment.isMoment(range[1])));
}
/**
 * 获取 disabled 部分
 */
export function getDisabledHours(_a, atRange) {
    var range = _a.range, _b = _a.disabledHours, disabledHours = _b === void 0 ? function () { return []; } : _b, _c = _a.hourStep, hourStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_1 = getHourMinuteSecond(range[0] || startOfDay);
        var max_1 = getHourMinuteSecond(range[1] || endOfDay);
        return __spread(disabledHours(), (atRange
            ? []
            : SEQUENCE_24.filter(function (i) { return i < min_1.hour || i > max_1.hour || i % hourStep !== 0; })));
    }
    return __spread(disabledHours(), SEQUENCE_24.filter(function (i) { return i % hourStep !== 0; }));
}
export function getDisabledMinutes(hour, _a, atRange) {
    var range = _a.range, _b = _a.disabledMinutes, disabledMinutes = _b === void 0 ? function () { return []; } : _b, _c = _a.minuteStep, minuteStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_2 = getHourMinuteSecond(range[0] || startOfDay);
        var max_2 = getHourMinuteSecond(range[1] || endOfDay);
        return __spread(disabledMinutes(hour), (atRange
            ? []
            : SEQUENCE_60.filter(function (i) {
                return (hour === min_2.hour && i < min_2.minute) ||
                    (hour === max_2.hour && i > max_2.minute) ||
                    i % minuteStep !== 0;
            })));
    }
    return __spread(disabledMinutes(hour), SEQUENCE_60.filter(function (i) { return i % minuteStep !== 0; }));
}
export function getDisabledSeconds(hour, minute, _a, atRange) {
    var range = _a.range, _b = _a.disabledSeconds, disabledSeconds = _b === void 0 ? function () { return []; } : _b, _c = _a.secondStep, secondStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_3 = getHourMinuteSecond(range[0] || startOfDay);
        var max_3 = getHourMinuteSecond(range[1] || endOfDay);
        return __spread(disabledSeconds(hour, minute), (atRange
            ? []
            : SEQUENCE_60.filter(function (i) {
                return (hour === min_3.hour && minute === min_3.minute && i < min_3.second) ||
                    (hour === max_3.hour && minute === max_3.minute && i > max_3.second) ||
                    i % secondStep !== 0;
            })));
    }
    return __spread(disabledSeconds(hour, minute), SEQUENCE_60.filter(function (i) { return i % secondStep !== 0; }));
}
export function getDisabledMilliseconds(hour, minute, second, _a, atRange) {
    var range = _a.range, _b = _a.disabledMilliseconds, disabledMilliseconds = _b === void 0 ? function () { return []; } : _b, _c = _a.millisecondsStep, millisecondsStep = _c === void 0 ? 1 : _c;
    if (isValidRange(range)) {
        var min_4 = getHourMinuteSecond(range[0] || startOfDay);
        var max_4 = getHourMinuteSecond(range[1] || endOfDay);
        return __spread(disabledMilliseconds(hour, minute, second), (atRange
            ? []
            : SEQUENCE_1000.filter(function (i) {
                return (hour === min_4.hour &&
                    minute === min_4.minute &&
                    second === min_4.second &&
                    i < min_4.milliseconds) ||
                    (hour === max_4.hour &&
                        minute === max_4.minute &&
                        second === max_4.second &&
                        i > max_4.milliseconds) ||
                    i % millisecondsStep !== 0;
            })));
    }
    return __spread(disabledMilliseconds(hour, minute, second), SEQUENCE_1000.filter(function (i) { return i % millisecondsStep !== 0; }));
}
/**
 * 在当前配置下是否为可选值
 */
export function isValidTimeValue(value, _a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.format, format = _b === void 0 ? "HH:mm:ss" : _b, _c = _a.hourStep, hourStep = _c === void 0 ? 1 : _c, _d = _a.minuteStep, minuteStep = _d === void 0 ? 1 : _d, _e = _a.secondStep, secondStep = _e === void 0 ? 1 : _e, _f = _a.millisecondsStep, millisecondsStep = _f === void 0 ? 1 : _f, props = __rest(_a, ["format", "hourStep", "minuteStep", "secondStep", "millisecondsStep"]);
    var _g = getHourMinuteSecond(value), hour = _g.hour, minute = _g.minute, second = _g.second, milliseconds = _g.milliseconds;
    var _h = genShowHourMinuteSecond(format), showHour = _h.showHour, showMinute = _h.showMinute, showSecond = _h.showSecond, showMilliseconds = _h.showMilliseconds;
    // 日期选择的时间校验：如果在日期的range之间，那这个范围的时间应该都是可选
    var atRange = isValidRange(props.range) &&
        value.isAfter(props.range[0]) &&
        value.isBefore(props.range[1]);
    // 范围校验
    if ((showHour && getDisabledHours(props, atRange).includes(hour)) ||
        (showMinute && getDisabledMinutes(hour, props, atRange).includes(minute)) ||
        (showSecond &&
            getDisabledSeconds(hour, minute, props, atRange).includes(second)) ||
        (showMilliseconds &&
            getDisabledMilliseconds(hour, minute, second, props, atRange).includes(milliseconds))) {
        return false;
    }
    // 步长校验
    if ((showHour && hour % hourStep) ||
        (showMinute && minute % minuteStep) ||
        (showSecond && second % secondStep) ||
        (showMilliseconds && milliseconds % millisecondsStep)) {
        return false;
    }
    return true;
}
/**
 * 获取自动调整后的合法值
 */
export function getValidTimeValue(_value, rangeOptions, format) {
    if (rangeOptions === void 0) { rangeOptions = {}; }
    if (format === void 0) { format = "HH:mm:ss"; }
    var value = moment.isMoment(_value) ? _value.clone() : _value;
    var _a = genShowHourMinuteSecond(format), showHour = _a.showHour, showMinute = _a.showMinute, showSecond = _a.showSecond, showMilliseconds = _a.showMilliseconds;
    var _b = getHourMinuteSecond(value || moment(0, "HH")), hour = _b.hour, minute = _b.minute, second = _b.second, milliseconds = _b.milliseconds;
    var _c = rangeOptions.hourStep, hourStep = _c === void 0 ? 1 : _c, _d = rangeOptions.minuteStep, minuteStep = _d === void 0 ? 1 : _d, _e = rangeOptions.secondStep, secondStep = _e === void 0 ? 1 : _e, _f = rangeOptions.millisecondsStep, millisecondsStep = _f === void 0 ? 1 : _f;
    var disabledHours = getDisabledHours(rangeOptions);
    if (showHour && (disabledHours.includes(hour) || hour % hourStep !== 0)) {
        hour = SEQUENCE_24.find(function (i) { return !disabledHours.includes(i); });
    }
    var disabledMinutes = getDisabledMinutes(hour, rangeOptions);
    if (showMinute &&
        (disabledMinutes.includes(minute) || minute % minuteStep !== 0)) {
        minute = SEQUENCE_60.find(function (i) { return !disabledMinutes.includes(i); });
    }
    var disabledSeconds = getDisabledSeconds(hour, minute, rangeOptions);
    if (showSecond &&
        (disabledSeconds.includes(second) || second % secondStep !== 0)) {
        second = SEQUENCE_60.find(function (i) { return !disabledSeconds.includes(i); });
    }
    var disabledMilliseconds = getDisabledMilliseconds(hour, minute, second, rangeOptions);
    if (showMilliseconds &&
        (disabledMilliseconds.includes(milliseconds) ||
            milliseconds % millisecondsStep !== 0)) {
        milliseconds = SEQUENCE_1000.find(function (i) { return !disabledMilliseconds.includes(i); });
    }
    return (value || moment()).set({ hour: hour, minute: minute, second: second, milliseconds: milliseconds });
}
//# sourceMappingURL=util.js.map